import { StateCard } from './StateCard'
import type { StateCardProps } from './StateCard'

// Scope ruling (P3 task 3): ChartCard exists so future chart panels have one
// obvious import, distinct from the ~19 non-chart panels on the dashboard
// that still hand-roll their own card shell. Those adopt StateCard directly
// in a later effort — not P3, which only touches the four chart components
// (BookValueChart, FleetValueOverlay, LifecycleFunnel, PicksPanel).
//
// Kept trivial on purpose: it's StateCard passing children straight through,
// with no chart-specific behavior added. Don't grow this into a place that
// bakes in a <ResponsiveContainer> or chart defaults — callers already own
// their own chart markup as `children`.
export function ChartCard(props: StateCardProps) {
  return <StateCard {...props} />
}
